import type { ExternalComponent, FullComponent } from "../../../../common/openapi";

function findExternalComponent({
	provisioning,
	synced,
}: Pick<FullComponent, "provisioning" | "synced">): undefined | ExternalComponent {
	return synced.find(({ externalId = "" }) => externalId === provisioning?.externalId);
}

export { findExternalComponent };
